import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function AboutMe() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>About Me - Full Stack Developer</title>
        <meta 
          name="description" 
          content="Learn more about me as a Full Stack Developer. Passionate about creating seamless digital experiences using modern web technologies like React, Node.js, Express.js, and more." 
        />
        <meta 
          name="keywords" 
          content="Full Stack Developer, web development, React, Node.js, Express.js, HTML, CSS, SCSS, Bootstrap, JavaScript" 
        />
        <meta name="author" content="Your Name" />
        <meta property="og:title" content="About Me - Full Stack Developer" />
        <meta property="og:description" content="Discover more about my skills and passion for building innovative web solutions." />
        <meta property="og:image" content="./img/heroimag.jpg" />
        <meta property="og:url" content="https://yourwebsite.com/about-me" />
      </Helmet>

      <section id="AboutMe" className="about--section">
        <div className="about--section--img">
          <img src="./img/heroimag.jpg" alt="About Me" />
        </div>
        <div className="hero--section--content--box about--section--box">
          <div className="hero--section--content">
            <p className="section--title">About</p>
            <h1 className="skills-section--heading">About Me</h1>
            <p className="hero--section-description">
              As a Full Stack Developer, I am passionate about 
              creating seamless and innovative digital experiences. With a
              strong foundation in both front-end and back-end technologies, 
              I thrive on the dynamic challenges of building robust, scalable, 
              and user-centric applications. My journey in web development has
              equipped me with a keen eye for design, coupled with the technical prowess 
              to bring ideas to life.
            </p>
            <p className="hero--section-description">
              Whether crafting engaging user
              interfaces with <span style={{color:'blue'}}> HTML</span>, <span style={{color:'blue'}}>CSS</span>, <span style={{color:'blue'}}>SCSS</span>, <span style={{color:'blue'}}>BOOTSTRAP</span>, and <span style={{color:'blue'}}> React.js</span> or
              architecting efficient server-side solutions using 
              <span style={{color:'blue'}}> Node.js</span> and <span style={{color:'blue'}}>Express.js</span>, I am committed to delivering high-quality,
              end-to-end solutions. My approach is rooted in continuous learning, 
              staying abreast of industry trends, and embracing new technologies to 
              ensure that my work remains at the forefront of modern development practices.
              I am driven by a genuine enthusiasm for problem-solving and a dedication to 
              creating impactful digital solutions that elevate the user experience.
            </p>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
}